module.exports = __webpack_public_path__ + "img/app-2-on.0dfcdabd.png";